import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import MTable from "components/Shared/MTable.tsx";
import { TextField, Button } from "react-md";
import { cloneDeep } from "lodash";
import { getAppraisalFormData, setAppraisalFormData } from "requests/homeowner/caseforms";
import responseHandler from "responseHandler";
import { connect } from "react-redux";
import { MSpinner } from "components/Shared";

const MitUpdate = props => {
  const [updateDataState, setUpdateDataState] = useState({});
  const [savingData, setSavingData] = useState(false);
  const [gettingData, setGettingData] = useState(false);
  const mounted = useRef(true);

  const exportResult = useRef(null);
  // useEffect here which will give us updateData
  const getUpdateData = () => {
    setGettingData(true);
    getAppraisalFormData(props.controlNumber, (response) => {
      exportResult.current = cloneDeep(response);
      setUpdateDataState(response.repeats.find(r => r.id === "repairsUpdates"));
      setGettingData(false);
    }, mounted);
  };
  useEffect(() => {
    getUpdateData();
    props.openPhotoTool();
  }, []);

  const handleOnChange = (row, val) => {
    let updateDataNextState = cloneDeep(updateDataState);
    updateDataNextState.groups[row.groupIndex].controls.find(c => c.id === "FN-468").value = val.toString();
    setUpdateDataState(updateDataNextState);
  };
  const columnDefinitions = [
    {
      name: "Update",
      // eslint-disable-next-line react/display-name
      dataSource: (row) => row.photoTags ? <a tabIndex="0" style={{ cursor: "pointer" }} onClick={() => { props.openPhotoTool(row.photoTags); }}>{row.label}</a> : row.label,
      addDepthWhitespace: true,
      className: "revision-source",
    },
    {
      name: "Date Completed",
      // eslint-disable-next-line react/display-name
      dataSource: (row) => <TextField onChange={val => handleOnChange(row, val)} value={row.dateCompleted} disabled={row.groupIndex == null} />,
      width: "200px"
    }
  ];

  /* data passed to MTable should have rows in this form
  [{
    key: "" // FN-123 
    label: ""
    dateCompleted: 
    depth: 
    depthKey: 1, 2, 3...
    groupIndex: // GET POST API will be in the form of groups: [{ controls: [], ... }]. This is the index of the group. Used to update state,
    photoTags: array of strings to pass it to the phototool to filter the photos by. Will be used when a label is clicked
  },...]
  */

  const createMTableDataRows = updateData => {
    let data = [];
    let depthKey = 0;
    let updateDataWithIndex = updateData.groups.map((r, i) => ({ ...r, index: i }));
    let interiorUpdatesDataRows = [];
    let exteriorUpdatesDataRows = [];
    updateDataWithIndex.forEach(r => {
      // if there is a update description. If empty there is no update, its just an empty control
      if (r.controls.find(c => c.id === "FN-467")?.value) {
        if (r.controls.find(c => c.id === "FN-464")?.value || ["Heating", "Plumbing", "Electrical", "Other Mechanical"].includes(r.controls.find(c => c.id === "FN-466")?.value)) {
          interiorUpdatesDataRows.push(r);
        } else {
          exteriorUpdatesDataRows.push(r);
        }
      }
    });

    const concatStr = (str1, str2) => {
      if (str1 && str2)
        return str1 + " " + str2;
      else if (str1) return str1;
      else if (str2) return str2;
      else return "";
    };
    const roomTypeFilter = (data, roomType) => data.filter(d => concatStr(d.controls.find(c => c.id === "FN-465").value, d.controls.find(c => c.id === "FN-464").value) === roomType);
    const updateCategoryFilter = (data, updateCategory) => data.filter(d => d.controls.find(c => c.id === "FN-466").value === updateCategory);
    const addGroupedRows = (updateDataRows) => {
      let roomTypeGroups = new Set();
      updateDataRows.forEach(d => roomTypeGroups.add(concatStr(d.controls.find(c => c.id === "FN-465").value, d.controls.find(c => c.id === "FN-464").value)));

      roomTypeGroups.forEach(roomType => {
        let roomTypeDataRows = roomTypeFilter(updateDataRows, roomType);
        data.push({
          label: roomType, depth: 2, depthKey: ++depthKey, groupIndex: null,
          photoTags: [roomTypeDataRows[0].controls.find(c => c.id === "FN-465").value, roomTypeDataRows[0].controls.find(c => c.id === "FN-464").value]
        });

        let updateCategoryGroups = new Set();
        roomTypeDataRows.forEach(d => updateCategoryGroups.add(d.controls.find(c => c.id === "FN-466").value));

        updateCategoryGroups.forEach(updateCategory => {
          let updateCategoryDataRows = updateCategoryFilter(roomTypeDataRows, updateCategory);
          data.push({ label: updateCategory, depth: 3, depthKey: ++depthKey, groupIndex: null, photoTags: [updateCategory] });

          updateCategoryDataRows.forEach(r => {
            data.push({
              label: r.controls.find(c => c.id === "FN-467").value,
              dateCompleted: r.controls.find(c => c.id === "FN-507").value, depth: 4, depthKey: ++depthKey, groupIndex: r.index, photoTags: [r.controls.find(c => c.id === "FN-467").value]
            });
          });
        });
      });
    };

    if (interiorUpdatesDataRows.length) {
      data.push({ label: "Interior Updates", depth: 1, depthKey: ++depthKey, groupIndex: null });

      addGroupedRows(interiorUpdatesDataRows);
    }

    if (exteriorUpdatesDataRows.length) {
      data.push({ label: "Exterior Updates", depth: 1, depthKey: ++depthKey, groupIndex: null });

      addGroupedRows(exteriorUpdatesDataRows);
    }

    return data;
  };

  const data = updateDataState?.groups ? createMTableDataRows(updateDataState) : [];

  const handleSave = () => {
    exportResult.current.repeats.find(r => r.id === "repairsUpdates").groups = updateDataState.groups;
    setSavingData(true);
    setAppraisalFormData(props.controlNumber, exportResult.current, () => {
      setSavingData(false);
      props.makeToast("Save Successful", "success");
      getUpdateData();
    }, mounted);
  };
  return gettingData ? <MSpinner /> : (
    <div className="case-data-history reo-repair">
      <Button primary raised onClick={handleSave} disabled={!exportResult.current || savingData || !data.length} style={{ marginBottom: 10 }}>Save</Button>
      <MTable columnDefinitions={columnDefinitions} data={data} keyProperty="depthKey" depthProperty="depth" emptyTableText="No updates present." />
    </div>
  );
};

MitUpdate.propTypes = {
  controlNumber: PropTypes.number,
  makeToast: PropTypes.func.isRequired,
  openPhotoTool: PropTypes.func.isRequired,
};
const mapDispatchToProps = (dispatch) => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});
export default connect(null, mapDispatchToProps)(MitUpdate);